/**
 * A component that displays a list of all modifications made by the current
 * user to a rep's time card that have not been acknowledged by that user.
 */
export const DashboardTimeEntryModificationsContainerComponent = {
    template: `
        <apex-dashboard-time-entry-modifications ng-if="$ctrl.loaded && $ctrl.timeEntryModifications.length"
                                                 time-entry-modifications="$ctrl.timeEntryModifications">
        </apex-dashboard-time-entry-modifications>`,
    require: {
        dashboardContext: "^apexDashboardContent"
    },
    controller: class DashboardModifiedTimeEntriesContainer {
        constructor($q, timeEntryComplianceService, utilityService) {
            'ngInject'
            this.$q = $q
            this.timeEntryComplianceService = timeEntryComplianceService
            this.utilityService = utilityService
            this.loaded = false
        }

        $onInit() {
            this.timeEntryComplianceService.retrieveUnacknowledgedTimeEntryModifications()
                .then(timeEntryModifications => {
                    this.timeEntryModifications = timeEntryModifications
                    this.loaded = true

                    if (this.dashboardContext) {
                        this.dashboardContext.activateDashboard({
                            visible: timeEntryModifications.length > 0,
                            count: timeEntryModifications.length
                        })
                    }
                })
        }
    }
}
